// extracted by mini-css-extract-plugin
export default {"bottomInfo":"index_bottomInfo_ninm6","innerBox":"index_innerBox_nAOb-","shareBox":"index_shareBox_UocrY"};